














































import Vue from "vue";
import CASScale from "@/components/ExternalDevices/CASScale.vue";
import CallerId from "@/components/ExternalDevices/CallerId.vue";
import MagellanScale from "@/components/ExternalDevices/MagellanScale.vue";
import Scanner from "@/components/ExternalDevices/Scanner.vue";
import { ExternalDevicesService } from "@/services/externalDevicesService";
import { Info } from "@/models/Info";

export default Vue.extend({
  name: "ExternalDevices",
  components: {
    CASScale,
    CallerId,
    MagellanScale,
    Scanner
  },
  props: {
    info: {
      type: Object as () => Info,
      default: null
    }
  },
  data() {
    return {
      saving: false,
      editValue: null as any,
      editModalVisible: false,
      selectedExternalDevice: "",
      isSettingChanged: false
    };
  },
  // watch: {
  //   "info.selectedDevice"(newValue) {
  //     this.externalDevices = this.selectedExternalDevices;
  //   }
  // },
  computed: {
    selectedExternalDevices(): any {
      return this.info.cloudSettings.find(p => p.deviceUDID == this.info.selectedDevice.deviceUDID)!.userDefaultsObject;
    }
  },
  methods: {
    settingChanged() {
      this.isSettingChanged = true;
    },
    editExternalDevice(device) {
      this.selectedExternalDevice = device;
    },
    async Save() {
      try {
        this.saving = true;
        let data = {};
        const CASScaleRef = this.$refs.CASScaleRef as any;
        const MagellanScaleRef = this.$refs.MagellanScaleRef as any;
        const ScannerRef = this.$refs.ScannerRef as any;
        const CallerIdRef = this.$refs.CallerIdRef as any;
        if (CASScaleRef) {
          data = Object.assign(data, CASScaleRef.getData());
        }
        if (MagellanScaleRef) {
          data = Object.assign(data, MagellanScaleRef.getData());
        }
        if (ScannerRef) {
          data = Object.assign(data, ScannerRef.getData());
        }
        if (CallerIdRef) {
          data = Object.assign(data, CallerIdRef.getData());
        }
        const result = await ExternalDevicesService.updateExternalDevices(this.info.selectedDevice.deviceUDID, data);
        if (result) {
          this.notyfy.success("Saved Successfully");
        } else {
          this.notyfy.error("Save Failded");
        }
        this.$emit("refresh");
      } catch (error) {
        this.notyfy.error("Save Failded");
      } finally {
        this.saving = false;
      }
    }
  }
});
